export type Sector = 'tech' | 'labs';

const STORAGE_KEY = 'arkron-sector';
const listeners: Array<(sector: Sector) => void> = [];

let currentSector: Sector = loadSector();

function loadSector(): Sector {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'labs' ? 'labs' : 'tech';
  } catch {
    return 'tech';
  }
}

function persistSector(sector: Sector): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, sector);
  } catch {
    // Ignore storage failures.
  }
}

export function initSector(): Sector {
  currentSector = loadSector();
  return currentSector;
}

export function getSector(): Sector {
  return currentSector;
}

export function setSector(sector: Sector): void {
  if (sector === currentSector) return;
  currentSector = sector;
  persistSector(sector);
  listeners.forEach((listener) => listener(currentSector));
}

export function onSectorChange(listener: (sector: Sector) => void): () => void {
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    if (index >= 0) listeners.splice(index, 1);
  };
}

export function bindSectorToggle(): void {
  const buttons = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-sector-btn]'));
  if (buttons.length === 0) return;

  const sync = (sector: Sector) => {
    buttons.forEach((button) => {
      const active = button.dataset.sector === sector;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.body.dataset.sector = sector;
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const sector = button.dataset.sector === 'labs' ? 'labs' : 'tech';
      setSector(sector);
    });
  });

  sync(currentSector);
  onSectorChange(sync);
}
